import {Component, inject} from '@angular/core';
import {LpCtaComponent} from "../../common/lp/lp-cta/lp-cta.component";
import {DOCUMENT} from '@angular/common';
import {ActivatedRoute} from '@angular/router';


@Component({
  selector: 'app-home-ambiance',
  imports: [
    LpCtaComponent
  ],
  templateUrl: './home-ambiance.component.html',
})
export class HomeAmbianceComponent {
  route = inject(ActivatedRoute)
  document = inject(DOCUMENT);

  goToEvents() {
    const homeEvents = this.document.getElementById('home-events')
    homeEvents.scrollIntoView({ behavior: 'smooth' });
  }
}
